const INTERACTIVE_PRODUCT = "interactive-product";

export const INTERACTIVE_CLASSES = {
	INTERACTIVE_PRODUCT,

	HOVER_ELEMENT: `${INTERACTIVE_PRODUCT}__interactive-hover-element`,
	ENABLE_PRODUCT_VISIBILITY: `${INTERACTIVE_PRODUCT}--enable-product-visibility`,

	BOTTOM_ELEMENT: `${INTERACTIVE_PRODUCT}__bottom-element`,

	TEXT: `${INTERACTIVE_PRODUCT}__text`,
	CENTER_ROW: `${INTERACTIVE_PRODUCT}__center-row`,
	BUTTON: `${INTERACTIVE_PRODUCT}__button`,

	TOP_ELEMENT: `${INTERACTIVE_PRODUCT}__top-element`,

	TOP_ICON_ROW: `${INTERACTIVE_PRODUCT}__top-icon-row`,
	TOP_ICON_ROW_SECTION: `${INTERACTIVE_PRODUCT}__top-icon-row__section`,

	BUTTON_WRAPPER: `${INTERACTIVE_PRODUCT}__button-wrapper`,
	BUTTON_WRAPPER_SMALL_ROUND: `${INTERACTIVE_PRODUCT}__button-wrapper--small-round`,
	BUTTON_WRAPPER_NORMAL_ROUND: `${INTERACTIVE_PRODUCT}__button-wrapper--normal-round`,

	BUTTON_WRAPPER_ICON: `${INTERACTIVE_PRODUCT}__button-wrapper__icon`,
	BUTTON_WRAPPER_ICON_COLORFUL_MOD: `${INTERACTIVE_PRODUCT}__button-wrapper__icon--colorful`,
	BUTTON_WRAPPER_ICON_COLORFUL_ACTIVE_MOD: `${INTERACTIVE_PRODUCT}__button-wrapper__icon--colorful--active`,
	BUTTON_WRAPPER_DISABLED_MOD: `${INTERACTIVE_PRODUCT}__button-wrapper--disabled`,
};

export const SCREEN_COVER_CLASS = "screen-cover";

export const FLEX_SPACER_CLASS = "flex-spacer";
